/// <reference path="Assistant.ts" />

namespace TerminalApp {


    export class BarcodeInputAssistant extends Assistant {
        bc_menu = document.createElement("div");
        additional_container: HTMLElement;
        ean_input: HTMLInputElement;
        colli_input: HTMLInputElement;
        submit_button: HTMLElement;
        resultCount = 0;
        additional: boolean = false;
        callback: (bc: string, colli_qty: number) => void;
        constructor() {
            super();
            this.bc_menu.innerHTML = `
                <h1>${SP.Localize("sentance_scan_barcode")}</h1>
                <center><img src="/terminal/img/scan.png"></center>
                <h1>${SP.Localize("sentance_enter_barcode")}</h1>
                <input type="text" placeholder="${SP.Localize("word_barcode")}" autocomplete="off" tabindex="1" style="margin-bottom:5px;" class="barcode_input search_input form-control">
                <div class='additional_barcode_info'>
                <h1>${SP.Localize("sentance_enter_colli_size")}</h1>
                <input type="number" placeholder="${SP.Localize("sentance_colli_size")} (${SP.Localize("word_default")}: 1)" autocomplete="off" tabindex="2" style="margin-bottom:5px;" class="colli_amount_input search_input form-control">
                </div>
                <div class="btn noselect grad-green"><span class="action">${SP.Localize("word_add")}</span></div>
            `; 
            this.additional_container = this.bc_menu.querySelector(".additional_barcode_info");
            this.ean_input = this.bc_menu.querySelector(".barcode_input");
            this.colli_input = this.bc_menu.querySelector(".colli_amount_input");
            this.submit_button = this.bc_menu.querySelector(".btn");
            this.submit_button.addEventListener("click", () => {
                this.callback(this.ean_input.value, parseInt(this.colli_input.value));
                this.close();
            });

            this.ean_input.addEventListener("keydown", (e) => {

                if (e.which == 13) this.submit_button.click();
            });

            this.container.appendChild(this.bc_menu);
        }


        hide() {
            this.bc_menu.style.display = "none";
        }

        open_bc() {
            this.hide();
            this.container.style.display = "block";
            this.bc_menu.style.display = "block";
            this.additional_container.style.display = this.additional ? "block" : "none";

        }

        clear() {
            //clear home buttons
            this.container.style.display = "none";
        }

        bound = false;

        async open(additional: boolean, callback: (bc: string, colli_qty: number) => void) {
            this.callback = callback;
            this.additional = additional;
            this.open_bc();

            this.ean_input.value = "";
            this.colli_input.value = "1";

            //this.ean_input.focus();

            if (!this.bound) {
                barcodeListener.on(null, this.scanBarcode, this);
                this.bound = true;
            }
        }




        close() {
            if (this.bound) {
                barcodeListener.off(null, this.scanBarcode);
                this.bound = false;
            }
            super.close();
        }

        scanBarcode(bc: string) {
            SP.blurActive();
            this.ean_input.value = bc;

            if (!this.additional) {
                this.submit_button.click();
            }
            else {
                this.colli_input.focus();
                this.colli_input.select();
            }

            return false;
        }
    }


}